import { DocumentIcon } from "web/components"

import { Button } from "web/components"

import { useModals } from "web/hooks/modals"

function DocumentAfterUploadSingle({ document, respond }) {
  const [documentName] = document.filename.match(/(.*)\.(.*)/).slice(1)

  function handleCreateDeal() {
    respond("NEW DEAL")
  }

  function handleGoToDeal() {
    respond("GO TO DEAL")
  }

  const attachmentHasDeal = "matching_deal_id" in document

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="flex gap-x-2.5">
          <div>
            <DocumentIcon width="48px" document={document} />
          </div>
          <div className="flex-auto">
            <div className="mb-2.5 text-sm font-medium">{documentName}</div>
            <div className="text-sm">
              {attachmentHasDeal
                ? "We found a deal related to this document."
                : "Would you like to create a deal from this document?"}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-commands">
        <div className="left-buttons">
          {attachmentHasDeal ? (
            <Button onClick={handleGoToDeal}>Go to Deal</Button>
          ) : (
            <Button
              onClick={handleCreateDeal}
              testId="button-document-uploaded-create-deal"
            >
              Create Deal
            </Button>
          )}
          <Button variant="tertiary_default" onClick={respond}>
            Cancel
          </Button>
        </div>
      </div>
    </>
  )
}

export default function useDocumentAfterUploadSingleModal() {
  const { showModal } = useModals()

  return async function (document) {
    return await showModal({
      title: "Document Uploaded",
      fullScreen: false,
      heightPixels: 250,
      widthPixels: 600,
      component: ({ respond }) => (
        <DocumentAfterUploadSingle document={document} respond={respond} />
      ),
    })
  }
}
